<template>
  <select class="lang-select" :value="$store.state.chats.chatLang" @input="$store.commit('SET_CHAT_LANGUAGE', {chatLang: $event.target.value})" @change="changeLanguage">
    <option v-for="language in langs" v-bind:key="language" v-bind:value="language" :selected="$store.state.chats.chatLang === language">{{ getLanguageName(language) }}</option>
  </select>
</template>

<script>
import languages from '../helpers/languages';

export default {
  name: "LangSelect",
  methods: {
    changeLanguage() {
      this.$store.dispatch("setChatLanguage");
    },
    getLanguageName(language) {
      return languages[language.slice(0, 2)].nativeName;
    }
  },
  computed: {
    langs() {
      return this.$store.getters.getAllChatLanguages;
    },
  },
};
</script>

<style lang="scss">
.lang-select {
  border: 1px solid #ddd;
  border-radius: 40px;
  padding: 2px 6px;
  margin-right: 15px;
  font-size: 12px;
}
</style>
